module.exports = __webpack_public_path__ + "static/media/logo.4d75fe23.svg";